export default "__VITE_ASSET__DW9aUe0h__"